import React,{useState} from "react";
import { Drawer, Table, Button, Row, Col } from "antd";
import {getBarcodePrintList} from "../../../../actions/BarcodePrintListAction.js"
import { connect } from "react-redux";
import moment from "moment";

// const Printvoucher = ({ details,getBarcodePrintList }) => {
//   const [tableData, setTableData] = useState([]);
const columns = [
  {
    title: "#",
    dataIndex: "serialNumber",
    key: "serialNumber",
  },
  {
    title: "Barcode",
    dataIndex: "barcode",
    key: "barcode",
  },
  {
    title: "Product",
    dataIndex: "product",
    key: "product",
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
  },
  {
    title: "Variation",
    dataIndex: "variation",
    key: "variation",
  },
];

const Printvoucher = ({ data,challanNumber, listQuantity, issueDate, comments  }) => {
    const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write('<html><head><title>Print</title>');
    // Add styles for space and border
    printWindow.document.write('<style>body{margin: 20px;} table{border-collapse: collapse; width: 100%; text-align:center;} table, th, td{border: 1px solid black;} h1{text-align:center} .footerSign{text-align:center}</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write('<h1>Barcoded Product List</h1>');
    printWindow.document.write(document.getElementById("printableTable").outerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <>
      <Button type="link" onClick={showDrawer}>
        View Print Voucher
      </Button>
      <Drawer
        title="Product Barcoded List"
        width={720}
        onClose={closeDrawer}
        visible={drawerVisible}
        placement="right"
      >
        <Button type="warning" onClick={handlePrint} style={{ marginTop: 16, marginBottom:10, backgroundColor:"black", color:"white" }}>
            Print List
        </Button>
        <div id="printableTable">
        <div style={{ marginBottom: 16, fontSize:14 }}>
            <strong style={{textAlign: "left"}}>Voucher Number:</strong> {challanNumber} &nbsp;&nbsp;
            <strong style={{textAlign: "right", marginLeft: 160}}>Issue Date:</strong> {moment(issueDate).format("DD-MM-YYYY")}
          </div>
          <div style={{ marginBottom: 16, fontSize:14 }}>
            <strong>List Quantity:</strong> {listQuantity}
          </div>
          <div style={{ marginBottom: 20, fontSize:14 }}>
            <strong>Comments:</strong> {comments}
          </div>

          <Table columns={columns} dataSource={data} rowKey={(record) => record.serialNumber} pagination={false}/>

          <div style={{marginTop: 100, marginBottom: 16, fontSize: 14 }}>
            <strong style={{textAlign: "left", borderTop: "2px solid black", display: "inline-block",}}>AUTHORIZER SIGNATURE</strong>
            <strong style={{textAlign: "right", marginLeft:160, borderTop: "2px solid black", display: "inline-block",}}> RECEIVER SIGNATURE</strong> 
          </div>

        </div>

      </Drawer>
    </>
  );
};

// export default connect(null, { getBarcodePrintList })(Printvoucher);
export default Printvoucher;